import { isWeb } from "@helpers/platform";
import type {
	BaseItemSchema,
	Choice,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import { Box } from "@memorang/ui";
import { sessionMaxWidth } from "../../../../constants";
import ChoicesList from "../../../choices/ChoicesList";

type Props = {
	multiSelect?: boolean;
	isSummativeTest?: boolean;
	isAnswered?: boolean;
	selectedChoiceIds?: string[];
	correctAnswerIds?: string[];
	crossedOutChoiceIds?: string[];
	choices: Choice[];
	showHint?: boolean;
	isMobile?: boolean;
	mappedItemType?: RenderableItemTypes;
	currentItem: BaseItemSchema;
	handleSelectChoice: (choiceId: string) => void;
	correctAnswerOrders?: string[];
};

const MCQ = ({
	multiSelect,
	isSummativeTest,
	isAnswered,
	selectedChoiceIds,
	correctAnswerIds,
	crossedOutChoiceIds,
	choices,
	isMobile,
	handleSelectChoice,
	currentItem,
	mappedItemType,
	correctAnswerOrders,
}: Props) => {
	return (
		<Box gap={16}>
			<Box
				paddingHorizontal={isSummativeTest || (isWeb && !isMobile) ? 0 : 16}
				maxWidth={isSummativeTest ? sessionMaxWidth.summative : 960}
			>
				<ChoicesList
					choices={choices}
					showCrossOut={!isSummativeTest}
					isAnswered={isAnswered}
					selectedChoiceIds={selectedChoiceIds}
					multiSelect={multiSelect}
					correctAnswerIds={correctAnswerIds}
					handleSelectChoice={handleSelectChoice}
					crossedOutChoiceIds={crossedOutChoiceIds}
					itemId={currentItem.id!}
					mappedItemType={mappedItemType}
					correctAnswerOrders={correctAnswerOrders}
					numChoicesRequired={currentItem.response?.numChoicesRequired}
				/>
			</Box>
			{/* {showHint && choices.length > 0 && (
				<Box paddingHorizontal={isWeb && !isMobile ? 0 : 16}>
					<HintContainer key={currentItem.id} item={currentItem} />
				</Box>
			)} */}
		</Box>
	);
};

export default MCQ;
